import { useMemo } from "react";
import cn from "classnames";
import { Accordion, AccordionSummary, AccordionDetails } from "@mui/material";
import { ExpandMore } from "@mui/icons-material";
import moment from "moment";
import { useInbox, useReadInbox } from "../../api/noticeApi";

const StudentInbox = () => {
  const { data, isLoading } = useInbox();
  const inboxes = useMemo(() => data?.inboxes, [data]);
  const { mutateAsync: readInbox } = useReadInbox();

  return (
    <div className="narrowContent">
      {isLoading ? (
        <p>로딩중...</p>
      ) : inboxes.length > 0 ? (
        <div>
          {inboxes.map((inbox: any) => (
            <Accordion className={cn("inbox", { read: inbox.read })}>
              <AccordionSummary
                expandIcon={<ExpandMore />}
                onClick={() => {
                  if (!inbox.read) {
                    readInbox({ id: inbox.id });
                  }
                }}
              >
                <p style={{ fontWeight: "500", fontSize: "1.2em" }}>
                  {inbox.title}
                </p>
              </AccordionSummary>
              <AccordionDetails>
                <p>보낸 사람: 한양대 스포츠지도사 연수원</p>
                <p>
                  보낸 시간: {moment(inbox.created_at).format("YYYY-MM-DD LT")}
                </p>
                <br />
                <p style={{ whiteSpace: "pre-wrap" }}>{inbox.content}</p>
              </AccordionDetails>
            </Accordion>
          ))}
        </div>
      ) : (
        <p>받은 메시지가 없습니다.</p>
      )}
    </div>
  );
};

export default StudentInbox;
